import * as React from "react";
import { PureComponent } from "react";
import { connect } from "react-redux";
import { ThunkDispatch } from "redux-thunk";
import { AnyAction } from "redux";
import { StoreState } from "src/external/store/storeState";
import { CustomerState } from "src/external/types/authentication";
import { TitleBar } from "src/external/types/titleBar";
import { setAppTitleBar } from "src/external/actions/appTitleBarActions";
import VideosMasterDetail from "src/common/Components/HelpVideos/VideosMasterDetail";
import { getVideosAction } from "src/common/actions/helpVideosActions";
import { withRouter, RouteComponentProps } from "react-router-dom";

interface HelpVideosPageReduxProps {
  auth: CustomerState;
}

interface HelpVideosPageDispatchProps {
  setAppTitle: (title: TitleBar) => void;
  getVideos: (path: string) => Promise<any>;
}

interface HelpVideosPageProps extends HelpVideosPageReduxProps, HelpVideosPageDispatchProps, RouteComponentProps<any> {}

class HelpVideosPage extends PureComponent<HelpVideosPageProps> {
  componentDidMount() {
    this.props.setAppTitle({
      title: "Help",
      description: ""
    });
    const path = this.props.auth.isServiceRep ? "branchstaff" : this.props.auth.isCustomer ? "member" : "guest";
    this.props.getVideos(path);
  }

  render() {
    return <VideosMasterDetail />;
  }
}
const mapStateToProps = (state: StoreState): HelpVideosPageReduxProps => {
  return {
    auth: state.authentication
  };
};

const mapDispatchToProps = (dispatch: ThunkDispatch<StoreState, void, AnyAction>): HelpVideosPageDispatchProps => {
  return {
    setAppTitle: (title: any) => {
      dispatch(setAppTitleBar(title));
    },
    getVideos: async (path: string) => {
      await dispatch(await getVideosAction(path));
    }
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withRouter(HelpVideosPage));
